// Event taxonomy — the ONLY event names the ingest endpoint accepts.
// docs/replan-v2.md R8 (stubbed per CLAUDE.md §37.1). Adding an event means:
// add it here, wire the call site, done — the API validates against this list
// so the `events` table never accumulates typo'd names.

export const EVENT_NAMES = [
  // Always-on first-party product analytics (no consent gate — engineering
  // telemetry, never resold; see packages/db schema/analytics.ts).
  'page_view',
  'view_pricing',
  'start_signup',
  'signup_success',
  'start_trial',
  'start_checkout',
  'subscription_started',
  'lesson_completed',
  'streak_at_risk',
  // Written server-side when a consent decision is recorded, so funnels can
  // segment by consent state without joining consent_records.
  'consent_updated',
] as const;

export type EventName = (typeof EVENT_NAMES)[number];

export function isEventName(value: string): value is EventName {
  return (EVENT_NAMES as readonly string[]).includes(value);
}

/** Where an event was emitted from. Mirrors the `event_source` pg enum. */
export type EventSource = 'web' | 'app' | 'admin' | 'api';
